import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Typography, Box, Chip, Grid, TextField } from "@mui/material";
import SelectParty from "components/party/components/SelectParty";
import { setAddOrderStoryState } from "store/slice/AppSlice";
import SelectProductOrderType from "./SelectProductOrderType";
import { addProductObj, setSelectedPharmaorderId, setSelectedProductId } from "store/slice/PharmaSlice";
import { addOrderAPI } from "api/OmsOrdermgmtWebServices";
import { addPharmaorderObj } from "store/slice/PharmaSlice";
import { setErrMsg, setInfoMsg } from "store/slice/AppSlice";
import { setShowEditForProduct } from "store/slice/PharmaSlice";
import {setPharmaorderManageProductsModal, setPharmaorderAddorderModal} from "store/slice/PharmaSlice";
import {setSelectedCTid} from "store/slice/AppSlice";
import FoodcompositionDashboard from '../components/foodcomposition/FoodcompositionDashboard';
import {setSelectedFoodcompositionId} from "store/slice/PharmaSlice";

export default function AddProductPage() {
  const dispatch = useDispatch()
  const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
  const {compositiontemplateObj} = useSelector((state) => state.pharmaslice.compositiontemplateDashboard);
  const { addOrderStory, } = useSelector((state) => state.appslice);
  const {orderType, selectedCTid, compType} = useSelector((state) => state.appslice);
  const {partyObj} = useSelector((state) => state.pharmaslice.partyDashboard);
  const {foodcompositionObj} = useSelector((state) => state.pharmaslice.foodcompositionDashboard);
  const [canInitiateOrder, setCanInitiateOrder] = useState(false);
  const {username} = useSelector((state) => state.headerslice.userprofileInfo);

  useEffect(()=>{
    if (compType==0){
      dispatch(setSelectedCTid(-1));
    }
  },[compType]);

  useEffect(() => {

    if (!compType) setCanInitiateOrder(false);

    if (compType==0){
      console.log("Selected CT ID in useEffect:selectedCTid=>", selectedCTid);
      if (selectedCTid!==undefined && selectedCTid!==null && selectedCTid!==-1)
        setCanInitiateOrder(true);
      else
      setCanInitiateOrder(false);
    }
    else if (compType==1){
      if  (foodcompositionObj && foodcompositionObj.id) {
        dispatch(setSelectedFoodcompositionId(foodcompositionObj.id));
        dispatch(setSelectedCTid(foodcompositionObj.id));
        setCanInitiateOrder(true);
      }
      else
      setCanInitiateOrder(false);
    }
    
   },[productObj,compositiontemplateObj,foodcompositionObj,compType,selectedCTid]);


    

  const addProductToOrder = () => {
    dispatch(setAddOrderStoryState({
      title: "Add Product to Order",
      description: "Add products to the order for the selected party",
      currentState: "ADD_PRODUCT_TO_ORDER",
    }));
  }

  const goToPartyPage = () => {
    dispatch(setAddOrderStoryState({
      title: "Select A Party",
      description: "Select a party to add an order",
      currentState: "SELECT_PARTY",
    }));
  }
  const goToEnterProductDetailsPageForNewOrder = () => {
    dispatch(setPharmaorderAddorderModal(false));
    dispatch(setPharmaorderManageProductsModal(true));
    //dispatch(setSelectedProductId(-1)); // Reset selected product ID for new order
    // dispatch(setAddOrderStoryState({
    //   title: "Enter Product Details",
    //   description: "Enter the details of the product to be added",
    //   currentState: "ENTER_PRODUCT_DETAILS",
    // }));
  }
  const isProductSelected = () => {
    console.log('orderType=>'+orderType);
    console.log('compositiontemplateObj.id=>'+compositiontemplateObj.id);

    if (orderType === "NEW" && compositiontemplateObj.id !== undefined) return false;
    if (orderType === "REPEAT" && productObj.id === undefined) return true;
    return true;

  }
  const addOrderAPISuccess = (response) => {
    console.log("Order added successfully:", JSON.stringify(response));
    dispatch(addPharmaorderObj(response.pharmaorderInfo));
      if (response.productInfo) {
        dispatch(addProductObj(response.productInfo));
        dispatch(setSelectedProductId(response.productInfo.id)); // Set the selected product ID
      } else {
        dispatch(setSelectedProductId(-1)); // Reset selected product ID if no product is returned
      }
      dispatch(setShowEditForProduct(true)); // Open the edit product
      
      dispatch(setInfoMsg("Order with '"+response.pharmaorderInfo.id+"' is created successfully. You can now add products to the order."));
      goToEnterProductDetailsPageForNewOrder();
  }
  const addOrderAPIFailure = (error) => {
    alert("Error adding order:", error);
  };  
  const handlePlaceOrder = () => {
    let compositiontemplateId = compositiontemplateObj.id;

    if (orderType==="REPEAT"){
      
      // Get the composition ID from the selected product
      if (productObj.id === undefined) {
        dispatch(setErrMsg("Please select a product to repeat the order."));
        return;
      }
      compositiontemplateId = productObj.ctid;
    }
      addOrderAPI({
        partyId: partyObj.id,
        ctid: selectedCTid,
        orderType: orderType,
        executiveName: username}
        ,addOrderAPISuccess, addOrderAPIFailure);
  }
  return (
    <>

      <SelectProductOrderType  />

      <Grid lg={12} xs={12} item sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", mt: 2 }}>
          <Grid container direction="row" alignItems="center" sx={{ width: '100%' }}>
            <Grid item lg={4} xs={4} sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
              <Button variant="outlined" color="secondary" onClick={() => goToPartyPage()} sx={{ mr: 2 }}>Back </Button>
            </Grid>
            <Grid item lg={8} xs={8} sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
              <Button
                variant="contained"
                onClick={() => handlePlaceOrder()}
                disabled={!canInitiateOrder}
                sx={{
                  '&.Mui-disabled': {
                    backgroundColor: 'secondary.400',
                    color: 'primary.contrastText',
                    opacity: 1,
                  },
                }}
              >
                Initiate Order
              </Button>

            </Grid>
          </Grid>
          </Grid>
        </>
        );
}